import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { User } from '../../services/userService'; // Assuming User type is exported from userService

interface ConnectionCardProps {
    connection: User;
    onRemove: (userId: number) => void; // Callback function to handle removal
}

const ConnectionCard: React.FC<ConnectionCardProps> = ({ connection, onRemove }) => {
    const { id, name, profession, company, city, country } = connection;
    const location = [city, country].filter(Boolean).join(', '); // Join city and country if they exist

    const handleRemoveClick = () => {
        // Add confirmation dialog later if desired
        onRemove(id);
    };

    return (
        <Card className="mb-3 border-0 shadow-sm connection-card">
            <Card.Body>
                <Row className="align-items-center">
                    <Col xs="auto">
                        {/* Placeholder for profile picture */}
                        <div 
                            className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center" 
                            style={{ width: '50px', height: '50px', fontSize: '1.2rem' }}
                        >
                            {name ? name.charAt(0).toUpperCase() : '?'} 
                        </div>
                    </Col>
                    <Col>
                        <h5 className="mb-0">
                            <Link to={`/profile/${id}`} className="text-decoration-none stretched-link">
                                {name || 'Unnamed User'}
                            </Link>
                        </h5>
                        {profession && <p className="mb-0 text-muted small">{profession}{company ? ` at ${company}` : ''}</p>}
                        {location && <p className="mb-0 text-muted small"><i className="fas fa-map-marker-alt me-1"></i>{location}</p>}
                    </Col>
                    <Col xs="auto">
                        <Button 
                            variant="outline-danger" 
                            size="sm" 
                            onClick={handleRemoveClick}
                            aria-label={`Remove ${name} connection`}
                            className="position-relative" // Ensure button is clickable over the Link
                            style={{ zIndex: 1 }} // Ensure button is clickable over the Link
                        >
                            <i className="fas fa-user-minus me-1"></i> Remove
                        </Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default ConnectionCard; 